import freshcutlawnbcFull from '@/assets/portfolio/freshcutlawnbc-full.webp'
import tailoroneFull from '@/assets/portfolio/tailorone-full.webp'
import { getCaseStudyByPortfolioName } from '@/content/work'
import {
  PortfolioClientWork,
  PortfolioLabWork,
} from '@/portfolio'

export type PortfolioProject = {
  name: string
  desc: string
  year: number
  img: string
  link: string
}

export type DisplayProject = {
  id: string
  client: string
  title: string
  subtitle: string
  category: string
  year: string
  image: string
  link: string
  caseStudyPath?: string
  excerpt: string
  color: string
  lab?: boolean
}

const GRADIENTS = [
  'from-pink-900/80 to-slate-900/90',
  'from-violet-900/80 to-slate-900/90',
  'from-fuchsia-900/80 to-slate-900/90',
  'from-rose-900/80 to-slate-900/90',
  'from-purple-900/80 to-slate-900/90',
  'from-indigo-900/80 to-slate-900/90',
  'from-slate-900/80 to-slate-900/90',
]

function imageSrc(img: string): string {
  return img
}

export function toDisplayProject(
  project: PortfolioProject,
  index: number,
  lab = false
): DisplayProject {
  return {
    id: `${lab ? 'lab' : 'client'}-${project.name}`,
    client: project.name,
    title: project.name,
    subtitle: project.desc,
    category: lab ? 'Lab build' : 'Client launch',
    year: String(project.year),
    image: imageSrc(project.img),
    link: project.link,
    caseStudyPath: getCaseStudyByPortfolioName(project.name)?.path,
    excerpt: project.desc,
    color: GRADIENTS[index % GRADIENTS.length],
    lab,
  }
}

export const allClientProjects = PortfolioClientWork.map((p, i) =>
  toDisplayProject(p, i, false)
)
export const allLabProjects = PortfolioLabWork.map((p, i) =>
  toDisplayProject(p, i, true)
)
export const allProjects = [...allClientProjects, ...allLabProjects]

const featuredOverrides: Record<string, Partial<DisplayProject>> = {
  'Fresh Cut Lawn BC': { image: imageSrc(freshcutlawnbcFull) },
  TailorOne: {
    image: imageSrc(tailoroneFull),
    category: 'CRM example',
    subtitle: 'Studio CRM for a tailoring business',
    excerpt:
      'Client records, orders, fittings, and production in one dashboard - built as a lab product to show how we ship custom CRMs.',
  },
}

/** Featured on homepage - hand-picked highlights */
export const featuredProjects: DisplayProject[] = [
  ...allClientProjects.filter((p) => p.title === 'Fresh Cut Lawn BC'),
  ...allLabProjects.filter((p) => p.title === 'TailorOne'),
].map((p) => ({ ...p, ...featuredOverrides[p.title] }))

/** Same screenshot as the portfolio card. */
export function getCaseStudyHero(portfolioName: string): string | undefined {
  return allProjects.find((project) => project.title === portfolioName)?.image
}
